import {useMemo} from 'react';
import {AutocompleteInput, Option} from './autocomplete-input';
import {UserType} from '../../backend/enums/user-type';
import {Skeleton} from '@mui/material';
import {translations} from '../../i18n/translations';
import {useTranslation} from 'react-i18next';
import {useFetchEntityUsers} from '../../hooks/use-fetch-entity-users';

interface RoleAutocompleteProps {
  defaultUserId?: string | undefined;
  onChange: (data: Option | undefined) => void;
  disabled?: boolean;
  emptyOptionLabel?: string;
}

export const RoleAutocomplete = ({
  defaultUserId,
  onChange,
  disabled,
  emptyOptionLabel,
}: RoleAutocompleteProps) => {
  const {t} = useTranslation();
  const {items: caregivers, isLoading} = useFetchEntityUsers({
    userType: UserType.Caregiver,
    activeUsers: true,
  });

  const options: Option[] = useMemo(
    () =>
      caregivers?.map(({user}) => ({
        key: user.id!,
        label: user.displayName || user.name,
        picture: user.picture || '',
      })) ?? [],
    [caregivers]
  );

  const selectedOption: Option | undefined = useMemo(
    () => options.find((option) => option.key === defaultUserId),
    [options, defaultUserId]
  );

  return (
    <>
      {isLoading ? (
        <Skeleton variant="rounded" width="234px" height={40} />
      ) : (
        <>
          <AutocompleteInput
            disabled={disabled}
            options={options}
            selectedOption={selectedOption}
            showEmptyOption
            emptyOptionLabel={
              emptyOptionLabel ?? t(translations.responsibleUserDropdown.noResponsibleDefined)
            }
            onChange={onChange}
          />
        </>
      )}
    </>
  );
};
